import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
    inputLabel: {
      fontSize: '14px',
      color: '#3C3C3C',
      marginBottom: '8px',
      lineHeight: '134.3%',
    },
  }));